var _excluded = ["onChange", "isReadOnly", "isViewMode", "isDisabled", "value", "options", "isInvalid", "name", "variant", "size", "id", "autoFocus"],
    _excluded2 = ["disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { uniqueId } from 'lodash';
import { forwardRef } from '../../../utils';
import { useStyleConfig } from '../../../utils/use-style-config';
import { Box } from '../../internal';
import { TextField } from '../TextField';
import { Radio } from './Radio';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";

function checkAutoFocus(autoFocusAttribute, selectedValue, value, index) {
  if (!autoFocusAttribute) {
    return false;
  }

  if (selectedValue) {
    return value === selectedValue;
  }

  return index === 0;
}

export var RadioGroup = forwardRef((_ref, ref) => {
  var {
    onChange,
    isReadOnly,
    isViewMode,
    isDisabled,
    value,
    options,
    isInvalid,
    name,
    variant,
    size,
    id,
    autoFocus
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var styles = useStyleConfig('RadioGroup', {
    variant
  });

  if (isViewMode) {
    var _optionToDisplay$main;

    var optionToDisplay = options.find(o => o.value === value);
    var displayValue = optionToDisplay === null || optionToDisplay === void 0 ? void 0 : (_optionToDisplay$main = optionToDisplay.mainLabelProps) === null || _optionToDisplay$main === void 0 ? void 0 : _optionToDisplay$main.label;
    return /*#__PURE__*/_jsx(TextField, _objectSpread(_objectSpread({}, props), {}, {
      size: size,
      isViewMode: true,
      defaultValue: displayValue
    }));
  }

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
    "data-component": "RadioGroup",
    ref: ref,
    role: "radiogroup"
  }, props), {}, {
    name,
    id,
    "aria-disabled": isDisabled,
    "aria-invalid": isInvalid,
    __css: styles,
    children: options.map((_ref2, index) => {
      var _disabled$isDisabled, _props$dataTestid;

      var {
        disabled
      } = _ref2,
          option = _objectWithoutProperties(_ref2, _excluded2);

      return /*#__PURE__*/_createElement(Radio, _objectSpread(_objectSpread({}, option), {}, {
        key: option.value,
        value: option.value,
        isDisabled: (_disabled$isDisabled = disabled === null || disabled === void 0 ? void 0 : disabled.isDisabled) !== null && _disabled$isDisabled !== void 0 ? _disabled$isDisabled : isDisabled,
        disabledMessage: disabled === null || disabled === void 0 ? void 0 : disabled.message,
        onChange: onChange,
        isChecked: option.value === value,
        isInvalid: isInvalid,
        name: name,
        id: uniqueId("".concat(id !== null && id !== void 0 ? id : 'radio-group', "_")),
        "data-testid": "".concat((_props$dataTestid = props['data-testid']) !== null && _props$dataTestid !== void 0 ? _props$dataTestid : 'radio-group', "-").concat(option.value),
        autoFocus: checkAutoFocus(!!autoFocus, value, option.value, index)
      }));
    })
  }));
});
RadioGroup.displayName = 'RadioGroup';
//# sourceMappingURL=RadioGroup.js.map